module.exports = __webpack_public_path__ + "static/img/goodsList_loading_duihaoli.f1f16665.png";